import { render, staticRenderFns } from "./EnrollmentFooter.vue?vue&type=template&id=36578a38&scoped=true&"
import script from "./EnrollmentFooter.vue?vue&type=script&lang=js&"
export * from "./EnrollmentFooter.vue?vue&type=script&lang=js&"
import style0 from "./EnrollmentFooter.vue?vue&type=style&index=0&id=36578a38&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36578a38",
  null
  
)

export default component.exports